var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { PagerControl, PagerControlDisabled } from '../../Table.styled';
import { Icon } from '@citrus/icon';
import { getAutomation, useMobile } from '@citrus/runtime';
import { useLocalization } from '@citrus/user';
import { isNilOrEmpty, isNotNilOrEmpty } from '@pcty/utils';
import { getVisiblePages, goBackAPageRange } from './utils';
import localizationMap from '../../../localization';
var Previous = function (_a) {
    var automationId = _a.automationId, disabled = _a.disabled, goToPage = _a.goToPage, itemCount = _a.itemCount, numberOfVisiblePages = _a.numberOfVisiblePages, page = _a.page, pageCount = _a.pageCount, pageSize = _a.pageSize;
    var lang = useLocalization(localizationMap);
    var mobile = useMobile(700);
    var goBackAPage = useCallback(function (e) {
        if (isNotNilOrEmpty(e)) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
        }
        var currentRange = getVisiblePages(mobile, numberOfVisiblePages, page, pageCount);
        if (currentRange[0] === page) {
            goToPage(goBackAPageRange(mobile, numberOfVisiblePages, page, pageCount, e));
            return;
        }
        goToPage(page - 1, e);
    }, [mobile, numberOfVisiblePages, page, pageCount, goToPage]);
    if (isNilOrEmpty(itemCount) || itemCount <= 0 || itemCount <= pageSize)
        return null;
    if (page === 1 || disabled) {
        return (React.createElement(PagerControlDisabled, __assign({ title: lang.goToPreviousPage }, getAutomation(automationId, 'prev')),
            React.createElement(Icon, { name: "chevron-left", title: lang.goToPreviousPage })));
    }
    return (React.createElement(PagerControl, __assign({ onClick: goBackAPage, title: lang.goToPreviousPage }, getAutomation(automationId, 'prev')),
        React.createElement(Icon, { name: "chevron-left", title: lang.goToPreviousPage })));
};
export default Previous;
